module.exports = __webpack_public_path__ + "static/media/blue-smoke-bg.5c318965.jpg";